import { render, staticRenderFns } from "./OrdersFBATable.vue?vue&type=template&id=21ec8c82&scoped=true"
import script from "./OrdersFBATable.vue?vue&type=script&lang=js"
export * from "./OrdersFBATable.vue?vue&type=script&lang=js"
import style0 from "./OrdersFBATable.vue?vue&type=style&index=0&id=21ec8c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ec8c82",
  null
  
)

export default component.exports